import { api } from '../main-api/apiClient';

export const systemAdminQuestionAPI = {
  // Get all questions with optional filtering
  getAllQuestions: async (filters = {}) => {
    const queryString = new URLSearchParams(filters).toString();
    return api.get(`/system-admin/questions?${queryString}`);
  },

  // Alias for backward compatibility
  getQuestions: async (filters = {}) => {
    const queryString = new URLSearchParams(filters).toString();
    return api.get(`/system-admin/questions?${queryString}`);
  },

  // Create new question
  createQuestion: async (questionData) => {
    const formData = new FormData();
    Object.keys(questionData).forEach(key => {
      if (questionData[key] !== null && questionData[key] !== undefined && questionData[key] !== '') {
        formData.append(key, questionData[key]);
      }
    });
    return api.post('/system-admin/questions', formData);
  },

  // Update existing question
  updateQuestion: async (questionId, questionData) => {
    const formData = new FormData();
    Object.keys(questionData).forEach(key => {
      if (questionData[key] !== null && questionData[key] !== undefined && questionData[key] !== '') {
        formData.append(key, questionData[key]);
      }
    });
    return api.put(`/system-admin/questions/${questionId}`, formData);
  },

  // Delete question
  deleteQuestion: async (questionId) => {
    return api.delete(`/system-admin/questions/${questionId}`);
  },

  // Reorder questions
  reorderQuestions: async (questionOrders) => {
    return api.post('/system-admin/questions/reorder', questionOrders);
  },

  // Get question analytics
  getQuestionAnalytics: async () => {
    return api.get('/system-admin/questions/analytics');
  },

  // Get question categories
  getQuestionCategories: async () => {
    return api.get('/system-admin/questions/categories');
  },

  // Create question category
  createQuestionCategory: async (categoryData) => {
    return api.post('/system-admin/questions/categories', categoryData);
  },

  // Update question category
  updateQuestionCategory: async (categoryId, categoryData) => {
    return api.put(`/system-admin/questions/categories/${categoryId}`, categoryData);
  },

  // Delete question category
  deleteQuestionCategory: async (categoryId) => {
    return api.delete(`/system-admin/questions/categories/${categoryId}`);
  },

  // Get question templates
  getQuestionTemplates: async () => {
    return api.get('/system-admin/questions/templates');
  },

  // Create question template
  createQuestionTemplate: async (templateData) => {
    return api.post('/system-admin/questions/templates', templateData);
  },

  // Update question template
  updateQuestionTemplate: async (templateId, templateData) => {
    return api.put(`/system-admin/questions/templates/${templateId}`, templateData);
  },

  // Delete question template
  deleteQuestionTemplate: async (templateId) => {
    return api.delete(`/system-admin/questions/templates/${templateId}`);
  }
};